import useSWR from 'swr';
import backendCommunicator from 'services/backendCommunicator';

import {SWRKeyEnum, URLPathname} from 'interfaces';
import Alert from 'helpers/Alert';
import {useGetNaturalComparator} from 'hooks/useGetNaturalComparator';
import {type MutableRefObject} from 'react';
import {useNavigate} from 'react-router-dom';

/**
 * @deprecated
 */
function useGetPlanTreeNavigation({planId, isMounted}: {planId?: string; isMounted: MutableRefObject<boolean>}) {
  const navigate = useNavigate();
  const naturalComparator = useGetNaturalComparator();

  const fetchPlanTreeNavigation = async ([planId]: [string]) => {
    try {
      const response = await backendCommunicator.getPlanTreeNavigation(planId);
      const planTreeNavigation = response.data;
      planTreeNavigation.sites?.sort((a, b) => naturalComparator(a.name, b.name));
      planTreeNavigation.sites?.forEach((site) => site.cages?.sort((a, b) => naturalComparator(a.name, b.name)));
      return planTreeNavigation;
    } catch (error) {
      if (isMounted.current) {
        Alert.error(error);
        navigate({pathname: URLPathname.notFound});
      }
    }
  };

  const {data, error} = useSWR(planId ? [planId, SWRKeyEnum.GET_PLAN_TREE_NAVIGATION] : null, fetchPlanTreeNavigation);

  return {
    planTreeNavigation: data,
    isLoading: planId && !error && !data,
  };
}

export default useGetPlanTreeNavigation;
